<template>
  <div
    class="row"
    v-if="namaRole != 'Penduduk' && showFilter"
  >
    <div class="col-lg-6">
      <div class="form-group row">
        <label
          for=""
          class="col-form-label col-lg-4 text-lg-right text-left"
        >Kecamatan</label>
        <div class="col-lg-8">
          <v-select
            v-model="filter.id_kecamatan"
            :options="optionKecamatan"
            label="nama_kecamatan"
            :loading="loadingKecamatan"
            :disabled="namaRole === 'Operator Desa' || namaRole === 'Kepala Desa' || namaRole === 'Operator Kecamatan'"
            :clearable="false"
          />
        </div>
      </div>
    </div>
    <div class="col-lg-6">
      <div class="form-group row">
        <label
          for=""
          class="col-form-label col-lg-4 text-lg-right text-left"
        >Desa</label>
        <div class="col-lg-8">
          <v-select
            v-model="filter.id_desa"
            :options="optionDesa"
            label="nama_desa"
            :loading="loadingDesa"
            :disabled="namaRole === 'Operator Desa' || namaRole === 'Kepala Desa'"
            :clearable="false"
          />
        </div>
      </div>
    </div>
    <div class="col-lg-6">
      <div class="form-group row">
        <label
          for=""
          class="col-form-label col-lg-4 text-lg-right text-left"
        >Layanan</label>
        <div class="col-lg-8">
          <v-select
            v-model="filter.id_layanan"
            :options="optionLayanan"
            label="nama_layanan"
            :loading="loadingLayanan"
            :clearable="false"
          >
            <template
              slot="option"
              slot-scope="option"
            >
              <div class="d-center">
                <!-- <img :src='option.owner.avatar_url'/>  -->
                <img
                  v-if="option.icon"
                  :src="$store.getters.getBaseUrl+'/uploads/icon-layanan/'+option.icon"
                  width="30px"
                  class="mr-2"
                >
                {{ option.nama_layanan }}
              </div>
            </template>
            <template
              slot="selected-option"
              slot-scope="option"
            >
              <div class="selected d-center">
                <img
                  v-if="option.icon"
                  :src="$store.getters.getBaseUrl+'/uploads/icon-layanan/'+option.icon"
                  width="20px"
                  class="mr-2"
                >
                {{ option.nama_layanan }}
              </div>
            </template>
          </v-select>
        </div>
      </div>
    </div>
    <div class="col-lg-6">
      <div class="form-group row">
        <label
          for=""
          class="col-form-label col-lg-4 text-lg-right text-left"
        >Pencarian</label>
        <div class="col-lg-8">
          <input
            type="text"
            class="form-control"
            v-model="search"
            placeholder="Cari berdasarkan Nama Penduduk/NIK"
          >
        </div>
      </div>
    </div>
    <div class="col-lg-6">
      <div class="form-group row">
        <label
          for=""
          class="col-form-label col-lg-4 text-lg-right text-left"
        >Tampilkan</label>
        <div class="col-lg-8">
          <select
            class="form-control"
            v-model="per_page"
          >
            <option value="5">
              Tampilkan tiap 5 data
            </option>
            <option value="10">
              Tampilkan tiap 10 data
            </option>
            <option value="25">
              Tampilkan tiap 25 data
            </option>
            <option value="50">
              Tampilkan tiap 50 data
            </option>
            <option value="100">
              Tampilkan tiap 100 data
            </option>
          </select>
        </div>
      </div>
    </div>
    <div class="col-lg-6">
      <div class="form-group row">
        <label
          for=""
          class="col-form-label col-lg-4 text-lg-right text-left"
        >Urutkan</label>
        <div class="col-lg-8">
          <select
            class="form-control"
            v-model="urutDariTerbaru"
          >
            <option value="0">
              Tampilkan yang lama lebih dulu
            </option>
            <option value="1">
              Tampilkan yang terbaru lebih dulu
            </option>
          </select>
        </div>
      </div>
    </div>
    <div class="col-lg-6">
      <div class="form-group row">
        <label
          for=""
          class="col-form-label col-lg-4 text-lg-right text-left"
        >Tanggal</label>
        <div class="col-lg-8">
          <div class="row">
            <div class="col-lg-6">
              <small>Dari tanggal</small>
              <input
                type="date"
                class="form-control"
                v-model="filter.tanggal_start"
              >
            </div>
            <div class="col-lg-6">
              <small>Sampai</small>
              <input
                type="date"
                class="form-control"
                v-model="filter.tanggal_end"
              >
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-lg-6" />
    <div class="col-lg-6">
      <div class="row">
        <div class="col-lg-8 offset-lg-4 text-right">
          <button
            class="btn btn-primary mx-1 mb-3"
            @click="terapkanFilter"
          >
            <i class="fa fa-filter mr-2" />Terapkan Filter
          </button>
          <button
            class="btn btn-danger mx-1 mb-3"
            @click="$emit('hapusFilter')"
          >
            <i class="fa fa-times mr-2" />Hapus Filter
          </button>
        </div>
      </div>
    </div>
    <div class="col-12">
      <hr>
    </div>
  </div>
</template>

<script>
import swal from 'sweetalert'

export default {
  data () {
    return {
      filter: {
        id_kecamatan: { id_kecamatan: 0, nama_kecamatan: 'SEMUA KECAMATAN' },
        id_desa: { id_desa: 0, nama_desa: 'SEMUA DESA' },
        id_layanan: { id_layanan: 0, nama_layanan: 'SEMUA LAYANAN' },
        tanggal_start: '',
        tanggal_end: ''
      },
      search: '',
      per_page: 5,
      optionKecamatan: [{
        id_kecamatan: 0,
        nama_kecamatan: 'Semua'
      }],
      optionDesa: [{
        id_desa: 0,
        nama_desa: 'SEMUA DESA'
      }],
      optionLayanan: [{
        id_layanan: 0,
        nama_layanan: 'SEMUA LAYANAN'
      }],
      loadingKecamatan: true,
      loadingDesa: false,
      loadingLayanan: false,
    }
  },
  props: {
    showFilter: {
      type: Boolean,
      default: () => null
    },
    filterData: {
      type: Object,
      default: () => null
    },
    urutDariTerbaruData: {
      type: Number,
      default: () => null
    },
    sortByDescData: {
      type: Boolean,
      default: () => null
    },
    searchData: {
      type: String,
      default: () => null
    },
    perPageData: {
      type: Number,
      default: () => null
    }
  },
  computed: {
    namaRole() {
      return this.$store.getters.getAuthService.currentRole.nama_role
    }
  },
  mounted () {
    this.filter = this.filterData
    this.urutDariTerbaru = parseInt(this.urutDariTerbaruData)
    this.sortByDesc = this.sortByDescData
    this.search = this.searchData
    this.per_page = parseInt(this.perPageData)

    this.loadKecamatan()

    this.loadAllLayanan()
  },
  methods: {
    terapkanFilter() {
      this.current_page = 1
      if (this.urutDariTerbaru == 0) {
        // kalau 0 brrti urut dari lama
        this.sortByDesc = false
      } else if (this.urutDariTerbaru == 1) {
        // kalau 1 brrti urut dari terbaru
        this.sortByDesc = true

      }
      this.$emit('setAdvancedFilter', {
        filter: this.filter,
        urutDariTerbaru: parseInt(this.urutDariTerbaru),
        sortByDesc: this.sortByDesc,
        search: this.search,
        per_page: parseInt(this.per_page)
      })
      this.$emit('loadPermohonan')
    },
    loadKecamatan() {
      this.$store.dispatch('fetchKecamatan', { id_kabupaten: 274 }).then(res => {
        if (res.data.status) {
          let optKec = []
          optKec.push({
            id_kecamatan: 0,
            nama_kecamatan: 'SEMUA KECAMATAN'
          })
          res.data.data.forEach(e => {
            optKec.push(e)
          })
          this.optionKecamatan = optKec

          // select kecamatan sesuai role
          if (this.namaRole === 'Operator Kecamatan' || this.namaRole === 'Operator Desa' || this.namaRole === 'Kepala Desa' || this.namaRole === 'Operator Dukcapil Kecamatan') {
            this.selectKecamatanByRole()
          }



          this.loadingKecamatan = false
        } else {
          swal({
            title: 'Gagal',
            text: res.data.message,
            icon: 'error',
            buttons: 'Ok'
          })
        }
      })
      // .catch(err => {
      //     console.log(err)
      // })
    },
    selectKecamatanByRole() {
      if (this.namaRole === 'Operator Dukcapil Kecamatan') {
        // jika operator dukcapil kecamatan, ambil dari rbac_user_op_duk_kec.
        // 1 usr bisa aja 2 kecamatan

        let idKecamatan = this.$store.getters.getAuthService.currentRole.id_kecamatan[0].id_kecamatan

        let selectedKecamatan = this.optionKecamatan.find(e => e.id_kecamatan === idKecamatan)
        this.filter.id_kecamatan = selectedKecamatan

      } else {

        let desaUser = this.$store.getters.getDesaUser // desa user di rbac_user! bukan di m_penduduk (untuk op)
        if (!desaUser) {
          this.$store.dispatch('fetchUser').then(res => {
            let user = this.$store.getters.getUser

            this.$store.dispatch('fetchDesa', { id_desa: user.id_desa }).then(res => {
              if (res.data.status) {
                this.$store.dispatch('setDesaUser', res.data.data[0]);

                desaUser = this.$store.getters.getDesaUser

                let id_kecamatan_user = desaUser.id_kecamatan
                let selectedKecamatan = this.optionKecamatan.find(e => e.id_kecamatan === id_kecamatan_user)
                this.filter.id_kecamatan = selectedKecamatan

              }
            })
          })
        } else {
          let id_kecamatan_user = desaUser.id_kecamatan
          let selectedKecamatan = this.optionKecamatan.find(e => e.id_kecamatan === id_kecamatan_user)
          this.filter.id_kecamatan = selectedKecamatan
        }
      }





      // let profil = this.$store.getters.getUserProfile
      // if(!this.profil){
      //     this.$store.dispatch('fetchUserProfile').then(res => {
      //         profil = this.$store.getters.getUserProfile
      //         let id_kecamatan_user = profil.desa.id_kecamatan
      //         let selectedKecamatan = this.optionKecamatan.find(e => e.id_kecamatan === id_kecamatan_user)

      //         this.filter.id_kecamatan = selectedKecamatan
      //     })
      // } else {
      //     let id_kecamatan_user = profil.desa.id_kecamatan
      //     let selectedKecamatan = this.optionKecamatan.find(e => e.id_kecamatan === id_kecamatan_user)

      //     this.filter.id_kecamatan = selectedKecamatan
      // }

    },
    loadDesa() {
      this.loadingDesa = true
      this.$store.dispatch('fetchDesa', { id_kecamatan: this.filter.id_kecamatan.id_kecamatan }).then(res => {
        if (res.data.status) {
          let optDes = []
          optDes.push({
            id_desa: 0,
            nama_desa: 'SEMUA DESA'
          })
          res.data.data.forEach(e => {
            optDes.push(e)
          })
          this.optionDesa = optDes

          if (this.namaRole === 'Operator Desa' || this.namaRole === 'Kepala Desa') {
            this.selectDesaByRole()
          }


          this.loadingDesa = false
        } else {
          swal({
            title: 'Gagal',
            text: res.data.message,
            icon: 'error',
            buttons: 'Ok'
          })
        }
      })
      // .catch(err => {
      //     console.log(err)
      // })
    },
    selectDesaByRole() {
      let desaUser = this.$store.getters.getDesaUser // desa user di rbac_user! bukan di m_penduduk (untuk op)
      if (!this.desaUser) {
        this.$store.dispatch('fetchUser').then(res => {
          let user = this.$store.getters.getUser

          this.$store.dispatch('fetchDesa', { id_desa: user.id_desa }).then(res => {
            if (res.data.status) {
              this.$store.dispatch('setDesaUser', res.data.data[0]);

              desaUser = this.$store.getters.getDesaUser

              let id_desa_user = desaUser.id_desa
              let selectedDesa = this.optionDesa.find(e => e.id_desa === id_desa_user)
              this.filter.id_desa = selectedDesa
            }
          })
        })
      } else {
        let id_desa_user = desaUser.id_desa
        let selectedDesa = this.optionDesa.find(e => e.id_desa === id_desa_user)
        this.filter.id_desa = selectedDesa
      }
    },
    loadAllLayanan() {
      this.$store.dispatch('fetchAllLayanan', true).then(res => {
        let layanan = this.$store.getters.getLayananAll
        // if(res.data.status){
        let optLayanan = []
        optLayanan.push({
          id_layanan: 0,
          nama_layanan: 'SEMUA LAYANAN'
        })
        layanan.forEach(e => {
          optLayanan.push(e)
        })
        this.optionLayanan = optLayanan
        this.loadingLayanan = false
        // } else {
        //     swal({
        //         title: 'Gagal',
        //         text: res.data.message,
        //         icon: 'error',
        //         buttons: 'Ok'
        //     })
        // }
      })
      // .catch(err => {
      //     console.log(err)
      // })
    }
  },
  watch: {
    'filter.id_kecamatan'(newVal, oldVal) {
      // check apa dia role op duk kecamatan?
      // kalo iya, cek dimana dia ditugaskan, kalau ubah ke kecamatan yang 
      // bukan tugas nya dia, kasi alert
      let authService = this.$store.getters.getAuthService
      let allowFilter = false

      if (this.namaRole === 'Operator Dukcapil Kecamatan') {

        authService.currentRole.id_kecamatan.forEach(e => {
          if (e.id_kecamatan == newVal.id_kecamatan) {
            allowFilter = true
          }
        })
      } else {
        allowFilter = true
      }

      if (allowFilter) {
        // console.log(newVal)
        this.loadDesa()
      } else {
        swal({
          title: 'Kesalahan',
          text: `Anda tidak diizinkan membuka data permohonan pada kecamatan ${oldVal.nama_kecamatan}.`,
          icon: 'error',
          buttons: 'Ok'
        })
        this.filter.id_kecamatan = 0
      }
    },
    filterData (newVal) {
      this.filter = newVal
    },
    urutDariTerbaruData (newVal) {
      this.urutDariTerbaru = newVal
    },
    sortByDescData (newVal) {
      this.sortByDesc = newVal
    },
    searchData (newVal) {
      this.search = newVal
    },
    perPageData (newVal) {
      this.per_page = newVal
    } 
  }
}
</script>